const mountAcceptanceRows = ({ privacyPolicies }) => {
  return privacyPolicies?.map((privacyPolicy) => ({
    id: privacyPolicy.id,
    title: privacyPolicy.title,
    acceptedTotal: privacyPolicy.acceptedTotal,
    percentage: privacyPolicy.acceptedTotal, // Na API já converte em porcentagem se for accepted_private == true
    acceptedPrivate: privacyPolicy.acceptedPrivate,
  }))
}

export default mountAcceptanceRows
